import { makeStyles } from '../../../../styles';
export const makeCustomStyles = (theme, warning, required, clearable) => ({
    control: (style, { isFocused }) => {
        const getBorderColor = () => {
            if (isFocused) {
                return theme.colors.primary.main;
            }
            else if (warning) {
                return theme.colors.warning.main;
            }
            else if (required) {
                return theme.colors.error.main;
            }
            else {
                return theme.colors.gray[200];
            }
        };
        return Object.assign(Object.assign({}, style), { borderRadius: 8, borderColor: getBorderColor(), boxShadow: 'none', fontSize: 14, color: theme.colors.text[900], transition: 'none', '&:hover': {
                borderColor: isFocused
                    ? theme.colors.primary.main
                    : theme.colors.text[700],
                boxShadow: 'none',
            } });
    },
    clearIndicator: (style) => ({
        alignItems: 'center',
        color: style.color,
        cursor: 'pointer',
        display: clearable ? 'flex' : 'none',
        height: 18,
        width: 18,
        '&:hover': {
            color: theme.palette.error.main,
        },
    }),
    dropdownIndicator: (style, { selectProps }) => (Object.assign(Object.assign({}, style), { transform: selectProps.menuIsOpen ? 'rotate(180deg)' : null })),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    menu: (style) => (Object.assign(Object.assign({}, style), { borderColor: theme.colors.gray[200], marginBottom: theme.spacing(0.5), marginTop: theme.spacing(0.5) })),
    multiValue: (style) => (Object.assign(Object.assign({}, style), { border: `1px solid ${theme.colors.gray[200]}`, borderRadius: theme.shape.borderRadius, backgroundColor: theme.colors.gray[0] })),
    multiValueLabel: (style) => (Object.assign(Object.assign({}, style), { padding: theme.spacing(0.5), fontSize: 12, color: theme.colors.gray[900] })),
    multiValueRemove: (style) => (Object.assign(Object.assign({}, style), { color: theme.colors.text[700] })),
    option: (style, { isFocused, isSelected }) => {
        const getColor = () => isSelected ? theme.colors.primary.main : theme.colors.gray[800];
        const getBackgroundColor = () => {
            if (isFocused) {
                return theme.colors.gray[100];
            }
            return theme.colors.primary.contrastWhite;
        };
        return Object.assign(Object.assign({}, style), { margin: `0 ${theme.spacing(0.5)}`, width: 'inherit', fontSize: 14, fontWeight: isSelected ? 600 : 'inherit', color: getColor(), backgroundColor: getBackgroundColor(), borderRadius: theme.shape.borderRadius, ':active': Object.assign(Object.assign({}, style[':active']), { color: getColor(), backgroundColor: getBackgroundColor() }) });
    },
    placeholder: (style) => (Object.assign(Object.assign({}, style), { color: theme.colors.text[600] })),
});
export const useStyles = makeStyles((theme) => ({
    title: Object.assign(Object.assign({}, theme.typography.subtitle1), { marginBottom: theme.spacing(0.5) }),
    clear: {
        marginBottom: theme.spacing(0.5),
        color: theme.colors.primary.main,
        fontSize: theme.spacing(1.5),
        cursor: 'pointer',
    },
    delete: {
        height: theme.spacing(1.5),
        width: theme.spacing(1.5),
    },
    errorMessageContainer: {
        color: theme.colors.error.main,
        display: 'flex',
        alignItems: 'center',
        marginTop: 4,
    },
    infoIcon: {
        fontSize: 14,
        marginRight: 4,
    },
}));
//# sourceMappingURL=SelectDropdownField.styles.js.map